import { API_URL } from "../config/connect";

const deleteNotification = async (notificationId) => {
    const endpoint = `${API_URL}/api/v1/admin/news/${notificationId}`;
    const googleIdToken = localStorage.getItem("google_id_token");
    const response = await fetch(endpoint, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${googleIdToken}` },
    });
    if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        const message =
            response.status === 403
                ? "Удалять уведомления может только администратор."
                : (typeof data?.detail === "string" && data.detail) || `Не удалось удалить уведомление (${response.status})`;
        throw new Error(message);
    }
    return response.json();
};

export default deleteNotification;
